import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'src/app/_core';

@Injectable({ providedIn: 'root' })
export class NavbarService {
  private readonly _translateService = inject(TranslateService);
  private readonly _router = inject(Router);

  getLocalizedUrl(key: string): string {
    const lang = this._translateService.currentLang || 'pl';
    const translatedPath = this._translateService.instant(key);

    const prefix = lang !== 'pl' ? `/${lang}` : '';

    const result = `/${translatedPath}`;

    return result;
  }

  isLinkActiveWithFragment(item: MenuItem): boolean {
    const tree = this._router.parseUrl(this._router.url);
    const currentUrl =
      '/' +
      (tree.root.children['primary']?.segments
        .map((s: any) => s.path)
        .join('/') ?? '');

    const itemUrl = this.getLocalizedUrl(item.url);

    const fragmentMatches = item.fragment
      ? tree.fragment === item.fragment
      : true;

    return currentUrl === itemUrl && fragmentMatches;
  }
}
